import LoginHeader from "./LoginHeader";
import LoginForm from "./LoginForm";
import WarningSnackbar from "../../widgets/Snackbar/WarningSnackbar";
import "./login.scss";

const Login = ({ showExpiryWarning, onCloseExpiryWarning, ...formProps }) => {
  return (
    <div className="login-wrapper">
      <div className="login-card">
        <LoginHeader />
        {showExpiryWarning && (
          <WarningSnackbar
            open={showExpiryWarning}
            message="Your session expired or you were logged in from another tab. Please log in again."
            onClose={onCloseExpiryWarning}
          />
        )}
        <LoginForm {...formProps} />
      </div>
    </div>
  );
};

export default Login;
